import PropTypes from "prop-types";
import { ModalBody } from "./modal-body.styles.es.js";
import { deprecated } from "../../prop-types-validators/deprecated.es.js";
const propTypes = {
  spacing: deprecated(PropTypes.oneOf(["default", "none"]))
};
const defaultProps = {
  spacing: void 0
};
ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;
export {
  ModalBody
};
